/* eslint-disable no-restricted-syntax */
/**
 * RedemptionService
 *
 * Service to handle redemption scenario for LocalStorageProxy (project fusion)
 *
 * When in BOF the presence of *redemptionCartID* takes priority over *cartID*.
 * IF *redemptionCartID* exists outside of the redemption funnel,
 * AND a *cartID* (DTC) operation is performed,
 * THEN *redemptionCartID* is cleaned up
 */
class RedemptionService {
    constructor() {
        this.PATH_WHITELIST = [
            '/account',
            '/product-registration',
            '/transaction'
        ];
        this.KEY = {
            redemptionCartID: 'redemptionCartID',
            cartID: 'cartID'
        };
    }
    static getInstance() {
        if (RedemptionService.instance) {
            return RedemptionService.instance;
        }
        return new RedemptionService();
    }
    /**
     * localeStorageProxy.setItem argument transformer
     *
     * @param {string} key - key to set in localStorage
     * @param {string} value - value to set in localStorage
     * @returns {Record<key|value, string>} - transformed key and value
     */
    handleSetItemArgs(key, value) {
        if (key !== this.KEY.cartID || !this.isValidScenario())
            return;
        this.log('setItem: cartID -> redemptionCartID');
        return {
            key: this.KEY.redemptionCartID,
            value
        };
    }
    /**
     * localeStorageProxy.getItem argument transformer
     *
     * @param {string} key - key to get from localStorage
     * @returns {Record<key, string | null>} - transformed key
     */
    handleGetItemArgs(key) {
        if (key !== this.KEY.cartID || !this.isValidScenario())
            return;
        this.log('getItem: cartID -> redemptionCartID');
        return { key: this.KEY.redemptionCartID };
    }
    /**
     * localeStorageProxy.removeItem argument transformer
     *
     * support preservation of cartID when BOF cleans up at the end of the redemption funnel*
     *
     * @param {string} key - key to get from localStorage
     * @returns {Record<key, string | null>} - transformed key
     */
    handleRemoveItemArgs(key) {
        if (key !== this.KEY.cartID || !this.isValidScenario())
            return;
        this.log('removeItem: cartID -> redemptionCartID');
        return { key: this.KEY.redemptionCartID };
    }
    /**
     * Handle cleanup of *redemptionCartID* when not in redemption funnel
     *
     * @param {string} key - localStorage key used during operation
     */
    checkCleanup(key) {
        if (key === 'cartID' && this.redemptionCartIDExists() && !this.isValidURL()) {
            localStorage.removeItem(this.KEY.redemptionCartID);
            this.log('cleanup redemptionCartID');
        }
    }
    isValidScenario() {
        return this.redemptionCartIDExists() && this.isValidURL();
    }
    redemptionCartIDExists() {
        return !!localStorage.getItem(this.KEY.redemptionCartID);
    }
    isValidURL() {
        return this.PATH_WHITELIST.some((path) => window.location.pathname.includes(path));
    }
    log(msg, ...args) {
        if (localStorage.getItem('debug')) {
            console.log(`RedemptionService: ${msg}`, ...args);
        }
    }
}
const redemptionService = RedemptionService.getInstance();

export { redemptionService };
//# sourceMappingURL=redemptionService.js.map
